export default __webpack_public_path__ + "static/posterThumbnail-6a57f8854e8a8cc319c52cc38cea42f5.png";